import { ComponentType } from 'react';
import { get, set } from 'lodash/fp';
import { getGrowthBookSSRData, GrowthBookSSRData, useGrowthBookSSR } from '@growthbook/growthbook-react';

import config from '../../src/client/config';

// @ts-expect-error - Automatic, Please fix when editing this file
export const generateGrowthBookSSRProps = async ({ req, resolvedUrl }) => {
  const gbClientId = get('cookies.gbClientId', req);
  const host = get('headers.host', req);

  return getGrowthBookSSRData({
    apiHost: config.get('growthbook:apiHost'),
    attributes: {
      id: gbClientId || '',
      url: `${host}${resolvedUrl}`,
    },
    clientKey: config.get('growthbook:clientKey'),
  });
};

// @ts-expect-error - Automatic, Please fix when editing this file
export const injectGrowthBookProps = async ({ context, props }) => {
  const growthBookData = await generateGrowthBookSSRProps(context);
  return {
    props: set('growthBookData', growthBookData, props),
  };
};

export type GrowthBookPageWrapperProps = {
  growthBookData: GrowthBookSSRData;
};

export const GrowthBookPageWrapper = <Props extends object>(
  props: GrowthBookPageWrapperProps & Props,
  Component: ComponentType<Props>,
): JSX.Element => {
  const { growthBookData, ...rest } = props as GrowthBookPageWrapperProps & Props;
  useGrowthBookSSR(growthBookData);
  return <Component {...(rest as Props)} />;
};
